export default (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => {
      const base64String = reader.result as string;
      return resolve(base64String);
    };

    reader.onerror = (error) => reject(error);
  });
};
